import { IJsonQueryUnderground } from '../../../packages/api-models/common/json_query';
import { TGeoValue, TJsonQuery, getGeoValue } from '../../../packages/JsonQuery';
import { getUniqGeo } from './getUniqGeo';

export function addUndergroundsToJsonQuery(jsonQuery: TJsonQuery, undergrounds: IJsonQueryUnderground[]): TGeoValue[] {
  const geo = getGeoValue()(jsonQuery);

  if (!geo) {
    return undergrounds;
  }

  const uniqUndergrounds = getUniqGeo(geo, undergrounds);

  return geo.concat(uniqUndergrounds);
}
